import { useQuery } from "react-query"

import { canCancelSubscription } from "../lib/subscriptions"

export function useCanCancelSubscription(
  ...args: Parameters<typeof canCancelSubscription>
) {
  return useQuery(["canCancelSubscription", ...args], () =>
    canCancelSubscription(...args),
  )
}
